const chatApi = () => eval("MyG2C.API.chatAsk('Inicio de chat.', 10)");
const chatApiHelp = () => eval("MyG2C.API.chatAsk('Solicitud de ayuda', 10)");
const chatApiCart = () => eval("MyG2C.API.chatAsk('Compra cancelada.', 10)");

export default { chatApi, chatApiCart, chatApiHelp };
